var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 192.000000 192.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,192.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497 1454 c-104 -19 -209 -63 -280 -119 -301 -237 -218 -690 154 -841 119 -49 180 -54 600 -54 l389 0 0 205 0 205 260 0 c143 0 260 2 260 5 0 3 -41 55 -92 115 l-91 110 -501 -1 -501 0 -85 -103 c-46 -57 -86 -109 -88 -115 -3 -8 71 -11 257 -11 l261 0 0 -76 0 -76 -237 4 c-237 4 -238 4 -301 32 -214 98 -201 361 22 445 53 20 76 21 359 21 l302 1 31 42 c17 23 64 84 103 135 l72 92 -408 -1 c-305 -1 -428 -4 -486 -15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.07af41122c988766ddc6a74a4be8da00.svg";
export { ForwardRef as ReactComponent };